module.exports = __webpack_public_path__ + "img/docs.78fe7177.svg";